import { MobileCarouselTabs } from 'lib/mobileDesignSystem';
import React from 'react';
import { useSearchParams } from 'react-router-dom';

import { CONFIRMING_DEFAULT_TAB, CONFIRMING_TABS } from './tabConfig';

const ConfirmingTabsView: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab = searchParams.get('c_tab') ?? CONFIRMING_DEFAULT_TAB;

  const handleChange = (value: string) => {
    setSearchParams(
      (prev) => {
        const next = new URLSearchParams(prev);
        next.set('c_tab', value);
        return next;
      },
      { replace: true },
    );
  };

  return (
    <MobileCarouselTabs
      items={CONFIRMING_TABS}
      value={activeTab}
      onChange={handleChange}
    />
  );
};

export default ConfirmingTabsView;
